import Logo from "./Logo";
import { useBrand } from "@/brand";

const navLinks = [
  { href: "#hero", label: "Startside" },
  { href: "#hvorfor", label: "Hvorfor {BRAND}" },
  { href: "#avtaler", label: "Strømavtaler B2B" },
  { href: "#infrastruktur", label: "Nett & Infrastruktur" },
  { href: "#fornybar", label: "Fornybar garanti" },
  { href: "#om-oss", label: "Om oss" },
];

const legalLinks = [
  { label: "Personvernerklæring (PDF)", href: "/personvernerklaring-rstrom.pdf" },
  { label: "B2B Avtalevilkår (PDF)", href: "TERMS_PDF" },
  { label: "Spotprisvilkår privat (PDF)", href: "/spotprisavtalevilkar-rstrom-privat.pdf" },
  { label: "Angreskjema (PDF)", href: "/angrerettskjema-rstrom.pdf" },
  { label: "Kraftsertifikater og NVE-data (kommer)", href: null },
];

const Footer = ({ basePath = "" }) => {
  const brand = useBrand();
  return (
  <footer className="bg-[#070D1E] text-slate-400 text-xs py-16 border-t border-white/5" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <Logo compact />
            <span className="text-base font-bold text-white tracking-tight">
              {brand.wordmarkTop}<span className="text-emerald-400">{brand.wordmarkAccent}</span>
            </span>
          </div>
          <p className="leading-relaxed mb-4 text-slate-400">
            Norsk strømleverandør for bedriftsmarkedet. Spotpris med aktiv
            prissikring og 100% fornybar energi.
          </p>
          <div className="text-[11px] text-slate-500">Org.nr: 937 756 763</div>
        </div>

        <div>
          <div className="font-bold text-white uppercase tracking-wider mb-4 text-xs">
            Navigasjon
          </div>
          <ul className="space-y-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={`${basePath}${l.href}`} className="hover:text-emerald-400 transition-colors" data-testid={`footer-link-${l.href.slice(1)}`}>
                  {l.label.replace("{BRAND}", brand.name)}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-bold text-white uppercase tracking-wider mb-4 text-xs">
            Kontaktinformasjon
          </div>
          <p className="text-slate-300 leading-relaxed mb-2 font-medium">{brand.companyLine}</p>
          <p className="leading-relaxed">Selma Ellefsens vei 6</p>
          <p className="leading-relaxed">0581 Oslo</p>
          <p className="mt-2 text-slate-300">
            Tlf:{" "}
            <a href="tel:+4792174274" className="hover:text-emerald-400 transition-colors" data-testid="footer-phone-link">
              921 74 274
            </a>
          </p>
          <p>
            E-post:{" "}
            <a href={`mailto:${brand.email}`} className="hover:text-emerald-400 transition-colors" data-testid="footer-email-link">
              {brand.email}
            </a>
          </p>
        </div>

        <div>
          <div className="font-bold text-white uppercase tracking-wider mb-4 text-xs">
            Juridisk &amp; Sikkerhet
          </div>
          <p className="leading-relaxed mb-3">{brand.legalLine}</p>
          <div className="space-y-1 text-slate-500 text-[11px]">
            {legalLinks.map((l) =>
              (l.href === "TERMS_PDF" ? brand.termsPdf : l.href) ? (
                <div key={l.label}>
                  <a
                    href={l.href === "TERMS_PDF" ? brand.termsPdf : l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 hover:text-emerald-400 transition-colors underline underline-offset-2"
                    data-testid="footer-terms-link"
                  >
                    {l.label}
                  </a>
                </div>
              ) : (
                <div key={l.label}>{l.label}</div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4 text-slate-500 text-[11px]">
        <div data-testid="footer-copyright">
          {brand.copyright}
        </div>
        <div className="text-emerald-400/80">For bedrifter og privatkunder i Norge</div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
